import { get } from 'libs/client/api-service'

export const fetcher = (url) => get(url)
